"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/AuthFrame/icons.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

// Stroked 20px icons for the signed-out screens, drawn from the approved
// mockups. They take currentColor, so the call site's CSS colours them.






const Icon = ({
  size = 20, className, children,
}) => (
  _react2.default.createElement('svg', {
    width: size,
    height: size,
    viewBox: "0 0 24 24"   ,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    'aria-hidden': "true",
    focusable: "false",
    className: className, __self: this, __source: {fileName: _jsxFileName, lineNumber: 14}}

    ,  children 
  )
)

 const AlertIcon = props => (
  _react2.default.createElement(Icon, { ...props, __self: this, __source: {fileName: _jsxFileName, lineNumber: 32}}
    , _react2.default.createElement('circle', { cx: "12", cy: "12", r: "9", __self: this, __source: {fileName: _jsxFileName, lineNumber: 33}} )
    , _react2.default.createElement('path', { d: "M12 7.5v5.5M12 16.5h.01"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 34}} )
  )
); exports.AlertIcon = AlertIcon

 const ChevronLeftIcon = props => (
  _react2.default.createElement(Icon, { ...props, __self: this, __source: {fileName: _jsxFileName, lineNumber: 39}}
    , _react2.default.createElement('path', { d: "M15 5l-7 7 7 7"    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}} )
  )
); exports.ChevronLeftIcon = ChevronLeftIcon

 const ExternalLinkIcon = props => (
  _react2.default.createElement(Icon, { ...props, __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}}
    , _react2.default.createElement('path', { d: "M14 4h6v6M20 4l-9 9M18 14v4a2 2 0 01-2 2H6a2 2 0 01-2-2V8a2 2 0 012-2h4"              , __self: this, __source: {fileName: _jsxFileName, lineNumber: 46}} )
  )
); exports.ExternalLinkIcon = ExternalLinkIcon

 const PhoneIcon = props => (
  _react2.default.createElement(Icon, { ...props, __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}}
    , _react2.default.createElement('rect', { x: "7", y: "2.5", width: "10", height: "19", rx: "2.5", __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}} )
    , _react2.default.createElement('path', { d: "M11 18.5h2" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}} )
  )
); exports.PhoneIcon = PhoneIcon

 const MailIcon = props => (
  _react2.default.createElement(Icon, { ...props, __self: this, __source: {fileName: _jsxFileName, lineNumber: 58}}
    , _react2.default.createElement('rect', { x: "3", y: "5", width: "18", height: "14", rx: "3", __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}} )
    , _react2.default.createElement('path', { d: "M4 7l8 6 8-6"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}} )
  )
); exports.MailIcon = MailIcon

 const CheckIcon = props => (
  _react2.default.createElement(Icon, { ...props, __self: this, __source: {fileName: _jsxFileName, lineNumber: 65}}
    , _react2.default.createElement('path', { d: "M5 12.5l4.5 4.5L19 7.5"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}} )
  )
); exports.CheckIcon = CheckIcon

 const LockIcon = props => (
  _react2.default.createElement(Icon, { ...props, __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}}
    , _react2.default.createElement('rect', { x: "5", y: "10.5", width: "14", height: "10", rx: "2.5", __self: this, __source: {fileName: _jsxFileName, lineNumber: 72}} )
    , _react2.default.createElement('path', { d: "M8 10.5V8a4 4 0 018 0v2.5"     , __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}} )
  )
); exports.LockIcon = LockIcon

 const InfoIcon = props => (
  _react2.default.createElement(Icon, { ...props, __self: this, __source: {fileName: _jsxFileName, lineNumber: 78}}
    , _react2.default.createElement('circle', { cx: "12", cy: "12", r: "9", __self: this, __source: {fileName: _jsxFileName, lineNumber: 79}} )
    , _react2.default.createElement('path', { d: "M12 11v5.5M12 7.5h.01"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 80}} )
  )
); exports.InfoIcon = InfoIcon
